import { createAction, props } from '@ngrx/store';

import { IrisSendMailI } from '@iris/common/models/IrisMail';

export const EmptyAction = createAction(
  '[DmsGlobal] Empty Action',
);

export const SetSelectedFolder = createAction(
  '[DmsGlobal] Set Selected Folder',
  props<{
    folderId: string;
    isHideFileSidebar?: boolean;
    expandFoldersTree?: boolean;
  }>(),
);

export const FolderSelected = createAction(
  '[DmsGlobal] Folder Selected',
  props<{
    folderId: string;
    isHideFileSidebar?: boolean;
    expandFoldersTree?: boolean;
  }>(),
);

export const ResetContentPage = createAction(
  '[DmsGlobal] Reset Content Page',
);

export const ResetModalPagePagination = createAction(
  '[DmsGlobal] Reset Modal Page Pagination',
);

export const ReloadCurrentPage = createAction(
  '[DmsGlobal] Reload Current Page',
);

export const DmsChangeCurrentProject = createAction(
  '[DmsGlobal] Change current project',
  props<{ projectId: number; doNotSelectFolder: boolean }>(),
);

export const SendEmailStart = createAction(
  '[DmsGlobal] Send email start',
  props<{ sendMail: IrisSendMailI }>(),
);

export const SendEmailSuccess = createAction(
  '[DmsGlobal] Send email success',
  props<{ sendMail: IrisSendMailI }>(),
);

export const SendEmailError = createAction(
  '[DmsGlobal] Send email error',
  props<{ sendMail: IrisSendMailI }>(),
);
